import { render, staticRenderFns } from "./VacancyProjectDescription.vue?vue&type=template&id=6762648a&scoped=true"
import script from "./VacancyProjectDescription.vue?vue&type=script&lang=js"
export * from "./VacancyProjectDescription.vue?vue&type=script&lang=js"
import style0 from "./VacancyProjectDescription.vue?vue&type=style&index=0&id=6762648a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6762648a",
  null
  
)

export default component.exports